import FeedIcon from '@mui/icons-material/Feed';
import HistoryIcon from '@mui/icons-material/History';
import InventoryIcon from '@mui/icons-material/Inventory';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import {
  Alert,
  Box,
  Button,
  Card,
  Chip,
  Container,
  LinearProgress,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import * as React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { DeliveryState } from '../../../enums/orders';
import { OrderType } from '../../../interfaces/delivery-company/orders';
import {
  cardHeaderStyle,
  cardStyle,
  cardTableStyle,
} from '../../common/styles/grid-card.style';
import {
  showDeliveryState,
  showPaymentState,
} from '../../common/styles/order-states.style';

import axios, { AxiosResponse } from 'axios';
import { API_ENDPOINT } from '../../../configurations/global.config';
import { AuthContext } from '../../../contexts/user-context/user-context';
import ConfirmAction from '../../common/confirm-action/confirm-action';

import { ErrorsFlattenner } from '../../common/errors-flattenner/errors-flattenner';
import { get_cod } from '../../../utils/cod';
import { OrgSettingsContext } from '../../../contexts/org-settings-context';
import { displayMoney } from '../../../utils/money';
import { displayDimensions } from '../../common/dimensions-input/utils';
import { ShopLocationType } from '../../../interfaces/delivery-company/pickups';
import MerchantCreatePickupLocationForm from '../merchant-pickup-locations/merchant-create-pickup-form/merchant-create-pickup-form';

function MerchantPickup() {
  const { pickupId } = useParams();
  return (
    <div>
      <Container>
        <Box>
          <MerchantCreatePickupLocationForm defaultPickupId={pickupId} />
        </Box>
      </Container>
    </div>
  );
}

export default MerchantPickup;
